/* eslint-disable @typescript-eslint/no-empty-function */
import { ReactElement, useState, createContext } from 'react';
import React from 'react';
import { AppConfiguration } from '../lib/type';
import { Scenario } from '../data/constants';

import Intro from './Intro/Intro';
import Questions from './Questions';
import Results from './Results/Results';

import IntroV2 from './v2/IntroV2/IntroV2';
import QuestionsV2 from './v2/QuestionsV2';
import ResultsV2 from './v2/ResultsV2/ResultsV2';
import '../assets/styles/main.scss';

export interface DORAAssessmentProps {
  configuration: AppConfiguration;
  contentV2: any;
}

export const layoutContext = createContext({
  currentScenario: '',
  setCurrentScenario: (type: Scenario) => {},
  selectedItems: {},
  setSelectedItems: (items: object) => {},
  selectedOption: {
    optionId: '',
    nextStep: '',
  },
  setSelectedOption: (items: { optionId: string; nextStep: string }) => {},
  questionId: '',
  setQuestionId: (id: string) => {},
  goToPrevious: false,
  setGoToPrevious: (previous: boolean) => {},
});

const DORAAssessment = ({
  configuration,
  contentV2,
}: DORAAssessmentProps): ReactElement => {
  const [currentScenario, setCurrentScenario] = useState(Scenario.introduction);
  const [selectedItems, setSelectedItems] = useState({});
  const [selectedOption, setSelectedOption] = useState({
    optionId: '',
    nextStep: '',
  });
  const [questionId, setQuestionId] = useState('q1');
  const [goToPrevious, setGoToPrevious] = useState(false);
  const getContryCode = () => {
    const lang =
      document.getElementsByTagName('html')[0].getAttribute('lang') || 'en';

    if (lang === 'en') {
      return 'us-en';
    } else {
      if (lang === 'id-id' || lang === 'ko-kr') {
        return 'us-en';
      } else {
        return lang?.split('-').reverse().join('-');
      }
    }
  };
  const cc = getContryCode();

  const handleScenario = () => {
    if (cc === 'us-en') {
      switch (currentScenario) {
        case 'introduction':
          return <IntroV2 contents={contentV2.introduction} />;
        case 'questions':
          return (
            <QuestionsV2
              contents={contentV2.questions}
              progressBarLabel={contentV2.introduction.title}
            />
          );
        case 'results':
          return <ResultsV2 contents={contentV2.results} />;
        default:
          return <IntroV2 contents={contentV2.introduction} />;
      }
    } else {
      switch (currentScenario) {
        case 'introduction':
          return <Intro contents={configuration.introduction} />;
        case 'questions':
          return <Questions contents={configuration.questions} />;
        case 'results':
          return <Results contents={configuration.results} />;
        default:
          return <Intro contents={configuration.introduction} />;
      }
    }
  };

  return (
    <layoutContext.Provider
      value={{
        currentScenario,
        setCurrentScenario,
        selectedItems,
        setSelectedItems,
        selectedOption,
        setSelectedOption,
        questionId,
        setQuestionId,
        goToPrevious,
        setGoToPrevious,
      }}
    >
      <div className="dora-assessment">{handleScenario()}</div>
    </layoutContext.Provider>
  );
};

export default DORAAssessment;
